import { Outlet, useLocation } from "react-router";
import {
  BaseDataPage,
  BaseDataPageContent,
  BaseDataPageHeader,
  BaseDataPageTitle,
} from "@/routes/base-data/_components/layout/base-data-page";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";
import t from "@/lang/lang";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { Alert403 } from "@/shared/components/alerts/alert-403";
import { CollapsibleDocumentPageNavigation } from "@/shared/bsm/core/document/components/ui/document-page";

export function QpmBaseDataRoute() {
  const { pathname } = useLocation();
  const canAccess = useFeatureAuth("gsm.qpm.basedata");
  if (!canAccess) {
    return (
      <BaseDataPage>
        <Alert403 />
      </BaseDataPage>
    );
  }

  return (
    <PersistenceContextProvider>
      <BaseDataPage>
        <BaseDataPageHeader>
          <BaseDataPageTitle className="flex justify-start gap-3">
            <span>
              <span className="text-primary">Q</span>uality
            </span>
            <span>
              <span className="text-primary">P</span>est{" "}
            </span>
            <span>
              <span className="text-primary">M</span>anagement
            </span>
            <span>
              <span className="text-primary">QPM&reg;</span>
            </span>
          </BaseDataPageTitle>
        </BaseDataPageHeader>
        <BaseDataPageContent>
          <CollapsibleDocumentPageNavigation
            label={t("Navigation")}
            currentLabel={
              qpmBaseDataNavigationLinks.find((link) =>
                pathname.endsWith(`/${link.to}`),
              )?.label
            }
            maxVisibleTabs={4}
            priorityTabs={[
              "base-data",
              "monitors",
              "catalog",
              "service-program",
            ]}
            links={qpmBaseDataNavigationLinks}
          />
          <Outlet />
        </BaseDataPageContent>
      </BaseDataPage>
    </PersistenceContextProvider>
  );
}

const qpmBaseDataNavigationLinks = [
  { to: "base-data", label: t("Basisdaten") },
  { to: "monitors", label: t("Monitore") },
  { to: "catalog", label: t("Monitorkataloge") },
  { to: "documentations", label: t("Dokumentationen") },
  { to: "calculation-parameters", label: t("Kalkulation Parameter") },
  { to: "offerdata", label: t("Angebotsdaten") },
  { to: "service-program", label: t("Leistungsprogramm") },
  { to: "certificates", label: t("Zertifikate") },
  { to: "companyreferences", label: t("Firmenreferenzen") },
];
